import { useCallback, useEffect, useState } from 'react'
import { airtableAPI, menusAPI, orderingAPI } from './api'

export function useKitchenData(cityId, menuId) {
  const [result, setResult] = useState(null)
  const [attempt, setAttempt] = useState(0)
  const refresh = useCallback(() => setAttempt((n) => n + 1), [])
  useEffect(() => {
    if (!cityId || !menuId) return
    let active = true
    let busy = false
    async function load() {
      if (busy) return
      busy = true
      try {
        const [menu, latest, ordering] = await Promise.all([
          menusAPI.get(menuId), airtableAPI.getLatest(cityId, menuId), orderingAPI.calculate(menuId),
        ])
        if (menu.city_id !== cityId) throw new Error('The menu belongs to another city.')
        if (active) setResult((old) => ({ cityId, menuId, menu, latest,
          ordering: old?.menuId === menuId && JSON.stringify(old.ordering) === JSON.stringify(ordering) ? old.ordering : ordering,
          checkedAt: new Date(), error: null }))
      } catch (error) {
        if (active) setResult((old) => ({ ...(old?.cityId === cityId && old?.menuId === menuId ? old : {}), cityId, menuId, error: error.message || 'Unable to refresh kitchen data.' }))
      } finally { busy = false }
    }
    load()
    const timer = setInterval(load, 30000)
    window.addEventListener('focus', load)
    return () => { active = false; clearInterval(timer); window.removeEventListener('focus', load) }
  }, [cityId, menuId, attempt])
  const current = result?.cityId === cityId && result?.menuId === menuId ? result : null
  return { ...current, loading: !current, refresh }
}
